module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.isShowNavbar) ? _c('TheNavbar', {
    ref: "TheNavBar",
    attrs: {
      "is-color": _vm.isNavbarColor
    }
  }) : _vm._e(), _vm._v(" "), _c('router-view', {
    attrs: {
      "id": "app-content"
    }
  }), _vm._v(" "), (_vm.isShowFooter) ? _c('TheFooter', {
    ref: "TheFooter"
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-427a9fc7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 125
// module chunks = 0